export const theme = {
  appColor: "#EB9E38",
  appColor2: "#D47A02",
};
